import { Animation, createAnimation, TransitionOptions } from "@ionic/react";

/**
 * Modal-style slide up transition from bottom
 * Creates a bottom sheet-like animation for page transitions
 */
export const modalSlideUpTransition = (_: HTMLElement, opts?: TransitionOptions): Animation => {
  const enteringEl = opts?.enteringEl as HTMLElement | undefined;
  const leavingEl = opts?.leavingEl as HTMLElement | undefined;

  if (!enteringEl) return createAnimation();

  const DURATION = 300;

  const enteringAnimation = createAnimation()
    .addElement(enteringEl)
    .duration(DURATION)
    .easing("cubic-bezier(0.32, 0.72, 0, 1)")
    .fromTo("transform", "translateY(100%)", "translateY(0)")
    .fromTo("opacity", "1", "1");

  if (!leavingEl) {
    return enteringAnimation;
  }

  const leavingAnimation = createAnimation()
    .addElement(leavingEl)
    .duration(DURATION)
    .easing("cubic-bezier(0.32, 0.72, 0, 1)");

  const rootAnimation = createAnimation().addAnimation([enteringAnimation, leavingAnimation]);

  return rootAnimation;
};

/**
 * Modal-style slide down transition (for going back)
 * Animates the page sliding down and off screen
 */
export const modalSlideDownTransition = (_: HTMLElement, opts?: TransitionOptions): Animation => {
  const enteringEl = opts?.enteringEl as HTMLElement | undefined;
  const leavingEl = opts?.leavingEl as HTMLElement | undefined;

  if (!leavingEl) return createAnimation();

  const DURATION = 250;

  const leavingAnimation = createAnimation()
    .addElement(leavingEl)
    .duration(DURATION)
    .easing("cubic-bezier(0.32, 0.72, 0, 1)")
    .fromTo("transform", "translateY(0)", "translateY(100%)")
    .fromTo("opacity", "1", "1");

  if (!enteringEl) {
    return leavingAnimation;
  }

  const enteringAnimation = createAnimation().addElement(enteringEl).duration(DURATION);

  const rootAnimation = createAnimation().addAnimation([enteringAnimation, leavingAnimation]);

  return rootAnimation;
};
